export function getQueryParams(): any{
    const queryParams = {} as any;
    const urlFragments = window.location.href.split("?");
    if (urlFragments[1]) {
        urlFragments[1].split("&").forEach(function (v) {
            const queryParamString = v.split("=");
            if (queryParamString.length === 2) {
                queryParams[queryParamString[0]] = queryParamString[1];
            }
        });

    }
    return queryParams;
}
